<template>
    <div class="fluid">
        <h1 class="app-title">Painel do Usuário – Dashboard</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <b-tabs content-class="mt-3" fill>
                        <b-tab title="Requisições Criadas pelo Usuário" active  @click="mudarAba(0)">
                            <TabelaCriadasUsuario
                                    :resultado="itemsCriadasUsuario"
                                    :configTable="configTableCriadasUsuario"
                                    :filtroComponente="filtro"
                                    :filtros="filtrosCriadasUsuario"
                                    :loading="this.$refs.loading"
                                    :selecteds="selectedsCriadasUsuario"
                                    @abrirExtrato="abrirExtrato"
                                    @abrirExtratoCda="abrirExtratoCda"
                                    @openFilterPopup="openFilterPopup"
                                    @consultar="consultar"
                                    @exportar="exportCSV"
                                    @limparFiltros="limparFiltros" />
                        </b-tab>
                        <b-tab title="Requisições submetidas à aprovação do Usuário" @click="mudarAba(1)" v-if="admin || procurador || tesoureiro">
                            <TabelaSubmetidasAprovacao
                                    :resultado="itemsSubmetidasAprovacao"
                                    :configTable="configTableSubmetidasAprovacao"
                                    :filtroComponente="filtro"
                                    :filtros="filtrosSubmetidasAprovacao"
                                    :loading="this.$refs.loading"
                                    :selecteds="selectedsSubmetidasAprovacao"
                                    @abrirExtrato="abrirExtrato"
                                    @abrirExtratoCda="abrirExtratoCda"
                                    @openFilterPopup="openFilterPopup"
                                    @consultar="consultar"
                                    @limparSelect="limparSelect"
                                    @exportar="exportCSV"
                                    @limparFiltros="limparFiltros" />
                        </b-tab>
                        <b-tab title="Requisições a validar pelo GOFS/Tesoureiro" @click="mudarAba(2)" v-if="admin || gofs || tesoureiro">
                            <TabelaRequisicaoGofsTesoureiro
                                    :resultado="itemsRequisicaoGofsTesoureiro"
                                    :configTable="configTableRequisicaoGofsTesoureiro"
                                    :filtroComponente="filtro"
                                    :filtros="filtrosRequisicaoGofsTesoureiro"
                                    :loading="this.$refs.loading"
                                    :selecteds="selectedsRequisicaoGofsTesoureiro"
                                    @abrirExtrato="abrirExtrato"
                                    @openFilterPopup="openFilterPopup"
                                    @consultar="consultar"
                                    @exportar="exportCSV"
                                    @limparSelect="limparSelect"
                                    @listarPorPendencia="listarPorPendencia"
                                    @limparFiltros="limparFiltros"/>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
        <CompLoading ref="loading"/>
        <ExtratoReceitasDiversas
                @closeModal="(update) => { updated = update; updateComponent(); }"
                ref="extratoDiversas"
                :loading="this.$refs.loading" />
        <ExtratoHonorariosAcaoJudicial
                @closeModal="(update) => { updated = update; updateComponent(); }"
                ref="extratoHonorariosAcaoJudicial"
                :loading="this.$refs.loading" />
        <ExtratoComunicacaoTransferencia
                @closeModal="(update) => { updated = update; updateComponent(); }"
                ref="extratoComunicacaoTransferencia"
                :loading="this.$refs.loading" />
        <ExtratoHonorariosProtesto
                @closeModal="(update) => { updated = update; updateComponent(); }"
                ref="extratoHonorariosProtesto"
                :loading="this.$refs.loading" />
        <ExtratoHonorariosEfSefa
                @closeModal="(update) => { updated = update; updateComponent(); }"
                ref="extratoHonorariosEfSefa"
                :loading="this.$refs.loading" />
        <ExtratoHonorariosComTransfEfSefa
                @closeModal="(update) => { updated = update; updateComponent(); }"
                ref="extratoHonorariosComTransfEfSefa"
                :loading="this.$refs.loading" />
        <ExtratoCda
                ref="extratoCda"
                :loading="this.$refs.loading" />
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import TabelaCriadasUsuario from "./components/TabelaCriadasUsuario";
    import CompLoading from "../shared/components/CompLoading";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import ExtratoReceitasDiversas from "../shared/components/ExtratoReceitasDiversas";
    import ExtratoHonorariosAcaoJudicial from "../shared/components/ExtratoHonorariosAcaoJudicial";
    import ExtratoComunicacaoTransferencia from "../shared/components/ExtratoComunicacaoTransferencia";
    import TabelaSubmetidasAprovacao from "./components/TabelaSubmetidasAprovacao";
    import TabelaRequisicaoGofsTesoureiro from "./components/TabelaRequisicaoGofsTesoureiro";
    import ExtratoHonorariosProtesto from "../shared/components/ExtratoHonorariosProtesto";
    import ExtratoHonorariosEfSefa from "../shared/components/ExtratoHonorariosEfSefa";
    import ExtratoHonorariosComTransfEfSefa from "../shared/components/ExtratoHonorariosComTransfEfSefa";
    import ExtratoCda from "../shared/components/ExtratoCda";

    export default {
        components: {
            ExtratoCda,
            ExtratoHonorariosComTransfEfSefa,
            ExtratoHonorariosEfSefa,
            ExtratoHonorariosProtesto,
            TabelaSubmetidasAprovacao,
            TabelaCriadasUsuario,
            TabelaRequisicaoGofsTesoureiro,
            ExtratoReceitasDiversas,
            ExtratoHonorariosAcaoJudicial,
            ExtratoComunicacaoTransferencia,
            FormWizard,
            TabContent,
            WizardStep,
            CompLoading,
            CompFiltroGrid
        },
        data() {
            return {
                updated: false,
                urlApi: null,
                token: null,
                tabIndex: 0,
                codigoReceita: null,
                boleto: null,
                admin: false,
                administrativo: false,
                procurador: false,
                gofs: false,
                tesoureiro: false,
                selectedsCriadasUsuario: [],
                selectedsSubmetidasAprovacao: [],
                selectedsRequisicaoGofsTesoureiro: [],
                itemsCriadasUsuario: [],
                itemsSubmetidasAprovacao: [],
                itemsRequisicaoGofsTesoureiro: [],
                configTableCriadasUsuario: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'pesquisa.numerorequisicao',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                configTableSubmetidasAprovacao: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'pesquisa.numerorequisicao',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                configTableRequisicaoGofsTesoureiro: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'pesquisa.numerorequisicao',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    campoTexto: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtrosCriadasUsuario: {
                    numeroRequisicao: null,
                    tipoRequisicacao: null,
                    cnj: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarUsuario: null,
                    usuario: null,
                    situacao: null,
                    cda: null
                },
                filtrosSubmetidasAprovacao: {
                    numeroRequisicao: null,
                    tipoRequisicacao: null,
                    cnj: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarUsuario: null,
                    usuario: null,
                    situacao: null,
                    filtrarUsuarioInclusao: null,
                    usuarioInclusao: null,
                    filtrarProcurador: null,
                    procurador: null,
                },
                filtrosRequisicaoGofsTesoureiro: {
                    numeroRequisicao: null,
                    tipoRequisicacao: null,
                    cnj: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarDataTransferencia: null,
                    dataTransferencia: null,
                    filtrarUsuarioInclusao: null,
                    usuarioInclusao: null,
                    filtrarSetor: null,
                    setor: null,
                    filtrarObservacoes: null,
                    observacoes: null,
                    filtrarDocumentos: null,
                    documentos: null,
                    validacaoGofs: null,
                    validacaoTesoureiro: null,
                    aprovadasReprovadas: false
                },
                load: false
            }
        },
        methods: {
            /* alteracao moser mantis 71446 */
            updateComponent () { 
                if (this.updated) {
                    this.consultar();
                    this.updated = false;
                }
            },
            async exportCSV(funcionalidade) {
                if(this.tabIndex == 0) {
                    this.filtrosCriadasUsuario.listaIds = this.selectedsCriadasUsuario;
                    this.executarExportCSV(this.itemsCriadasUsuario, this.configTableCriadasUsuario, funcionalidade, this.filtrosCriadasUsuario);
                } else if(this.tabIndex == 1) {
                    this.filtrosSubmetidasAprovacao.listaIds = this.selectedsSubmetidasAprovacao;
                    this.executarExportCSV(this.itemsSubmetidasAprovacao, this.configTableSubmetidasAprovacao, funcionalidade, this.filtrosSubmetidasAprovacao);
                } else if(this.tabIndex == 2) {
                    this.filtrosRequisicaoGofsTesoureiro.listaIds = [];
                    for(let i = 0; i < this.selectedsRequisicaoGofsTesoureiro.length; i++) {
                        this.filtrosRequisicaoGofsTesoureiro.listaIds.push(this.selectedsRequisicaoGofsTesoureiro[i].numeroRequisicao);
                    }
                    this.executarExportCSV(this.itemsRequisicaoGofsTesoureiro, this.configTableRequisicaoGofsTesoureiro, funcionalidade, this.filtrosRequisicaoGofsTesoureiro);
                }
            },
            async executarExportCSV(items, configTable, funcionalidade, filtros) {
                this.$store.commit("setMessages", null);
                if(items.length == 0) {
                    this.$store.commit("setMessages", { message: 'Erro!', errors: [{message: "Não há registros a serem exportados."}] });
                } else {
                    this.$refs.loading.showLoading();
                    axios.post(`${this.urlApi}/v1/painelUsuario/exportarCsv/${funcionalidade}?sortField=${configTable.sortField}&sortOrder=${configTable.sortOrder}`, filtros, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        if(this.tabIndex == 0) {
                            link.setAttribute('download', 'Requisições Criadas pelo Usuário.csv');
                        } else if(this.tabIndex == 1) {
                            link.setAttribute('download', 'Requisições submetidas à aprovação do Usuário.csv');
                        } else if(this.tabIndex == 2) {
                            link.setAttribute('download', 'Requisições a validar pelo GOFS-Tesoureiro.csv');
                        }
                        document.body.appendChild(link);
                        link.click();
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    });
                }
            },

            mudarAba(index) {
                this.tabIndex = index;
                this.consultar();
            },

            consultar() {
                if(this.tabIndex == 0) {
                    this.filtrosCriadasUsuario.listaIds = null;
                    this.consultarPorTipo('consultarRequisicoesUsuario',
                        this.configTableCriadasUsuario,
                        this.filtrosCriadasUsuario);
                } else if(this.tabIndex == 1) {
                    this.filtrosSubmetidasAprovacao.listaIds = null;
                    this.consultarPorTipo('consultarRequisicoesAprovacao',
                        this.configTableSubmetidasAprovacao,
                        this.filtrosSubmetidasAprovacao);
                } else if(this.tabIndex == 2) {
                    this.filtrosRequisicaoGofsTesoureiro.listaIds = null;
                    this.consultarPorTipo('consultarRequisicoesValidacoes',
                        this.configTableRequisicaoGofsTesoureiro,
                        this.filtrosRequisicaoGofsTesoureiro);
                }
            },

            limparSelect() {
                if(this.tabIndex == 0) {
                    this.selectedsCriadasUsuario = [];
                } else if(this.tabIndex == 1) {
                    this.selectedsSubmetidasAprovacao = [];
                } else if(this.tabIndex == 2) {
                    this.selectedsRequisicaoGofsTesoureiro = [];
                }
            },

            async consultarPorTipo(method, configTable, filtros) {
                let perPageStr = `&perPage=${configTable.perPage}`;
                if (configTable.perPage === 'Todos') {
                    perPageStr = '';
                    configTable.currentPage = 1;
                    configTable.rows = 0;
                }

                configTable.load = true;
                axios.post(`${this.urlApi}/v1/painelUsuario/${method}?page=${configTable.currentPage}${perPageStr}&sortField=${configTable.sortField}&sortOrder=${configTable.sortOrder}`, filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(method == 'consultarRequisicoesUsuario') {
                        this.itemsCriadasUsuario = response.data.resultado;
                    } else if(method == 'consultarRequisicoesAprovacao') {
                        this.itemsSubmetidasAprovacao = response.data.resultado;
                        for(var i = 0; i < this.selectedsSubmetidasAprovacao.length; i++) {
                            for (var j = 0; j < this.itemsCriadasUsuario.length; j++) {
                                if (this.itemsCriadasUsuario[j].id == this.selectedsSubmetidasAprovacao[i].id
                                    && this.itemsCriadasUsuario[j].tabelaOrigem == this.selectedsSubmetidasAprovacao[i].tabelaOrigem) {
                                    this.selectedsSubmetidasAprovacao[i] = this.itemsCriadasUsuario[j];
                                }
                            }
                        }
                    } else if(method == 'consultarRequisicoesValidacoes') {
                        this.itemsRequisicaoGofsTesoureiro = response.data.resultado;
                        for(var i = 0; i < this.selectedsRequisicaoGofsTesoureiro.length; i++) {
                            for (var j = 0; j < this.itemsRequisicaoGofsTesoureiro.length; j++) {
                                if (this.itemsRequisicaoGofsTesoureiro[j].id == this.selectedsRequisicaoGofsTesoureiro[i].id
                                    && this.itemsRequisicaoGofsTesoureiro[j].tabelaOrigem == this.selectedsRequisicaoGofsTesoureiro[i].tabelaOrigem) {
                                    this.selectedsRequisicaoGofsTesoureiro[i] = this.itemsRequisicaoGofsTesoureiro[j];
                                }
                            }
                        }
                    }

                    if (configTable.perPage !== 'Todos') {
                        configTable.rows = response.data.rows;
                        configTable.lastPage = Math.ceil(configTable.rows / configTable.perPage);
                    } else {
                        configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    configTable.load = false;
                })
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.tabIndex == 0) {
                        this.atribuirFiltro(this.filtrosCriadasUsuario);
                    } else if(this.tabIndex == 1) {
                        this.atribuirFiltro(this.filtrosSubmetidasAprovacao);
                    } else if(this.tabIndex == 2) {
                        this.atribuirFiltro(this.filtrosRequisicaoGofsTesoureiro);
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            atribuirFiltro(filtroTab){
                if(this.filtro.campoFiltro == 'Número Requisição') {
                    this.filtro.campoMascara = filtroTab.numeroRequisicao;
                } else if(this.filtro.campoFiltro == 'Tipo Requisição') {
                    this.filtro.campoCheckbox = filtroTab.tipoRequisicacao;
                } else if(this.filtro.campoFiltro == 'Processo') {
                    this.filtro.campoMascara = filtroTab.cnj;
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.filtro.filtrarEm = filtroTab.filtrarContribuinte;
                    this.filtro.campoTexto = filtroTab.contribuinte;
                } else if(this.filtro.campoFiltro == 'Data Emissão') {
                    this.filtro.filtrarEm = filtroTab.filtrarDataEmissao;
                    this.filtro.campoData = filtroTab.dataEmissao;
                } else if(this.filtro.campoFiltro == 'Data Transf.') {
                    this.filtro.filtrarEm = filtroTab.filtrarDataTransferencia;
                    this.filtro.campoData = filtroTab.dataTransferencia;
                } else if(this.filtro.campoFiltro == 'Forma Pagamento') {
                    this.filtro.campoCheckbox = filtroTab.formaPagamento;
                } else if(this.filtro.campoFiltro == 'Tipo Pagamento') {
                    this.filtro.campoCheckbox = filtroTab.tipoPagamento;
                } else if(this.filtro.campoFiltro == 'Valor') {
                    this.filtro.filtrarEm = filtroTab.filtrarValor;
                    this.filtro.campoTexto = filtroTab.valor;
                } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                    this.filtro.campoCheckbox = filtroTab.situacao;
                } else if(this.filtro.campoFiltro == 'Cadastrada por (serv/estag)' || this.filtro.campoFiltro == 'Usuário Responsável') {
                    this.filtro.filtrarEm = filtroTab.filtrarUsuarioInclusao;
                    this.filtro.campoTexto = filtroTab.usuarioInclusao;
                } else if(this.filtro.campoFiltro == 'A ser aprovada por (Procurador)') {
                    this.filtro.filtrarEm = filtroTab.filtrarProcurador;
                    this.filtro.campoTexto = filtroTab.procurador;
                } else if(this.filtro.campoFiltro == 'Setor') {
                    this.filtro.filtrarEm = filtroTab.filtrarSetor;
                    this.filtro.campoTexto = filtroTab.setor;
                } else if(this.filtro.campoFiltro == 'Observações') {
                    this.filtro.filtrarEm = filtroTab.filtrarObservacoes;
                    this.filtro.campoTexto = filtroTab.observacoes;
                } else if(this.filtro.campoFiltro == 'Documentos Anexos') {
                    this.filtro.filtrarEm = filtroTab.filtrarDocumentos;
                    this.filtro.campoTexto = filtroTab.documentos;
                } else if(this.filtro.campoFiltro == 'Validação GOFS') {
                    this.filtro.campoCheckbox = filtroTab.validacaoGofs;
                } else if(this.filtro.campoFiltro == 'Validação Tesoureiro') {
                    this.filtro.campoCheckbox = filtroTab.validacaoTesoureiro;
                } else if(this.filtro.campoFiltro == 'CDAs') {
                    this.filtro.campoMascara = filtroTab.cda;
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.tabIndex == 0) {
                    this.popularFiltroTab(this.filtrosCriadasUsuario, this.configTableCriadasUsuario);
                } else if(this.tabIndex == 1) {
                    this.popularFiltroTab(this.filtrosSubmetidasAprovacao, this.configTableSubmetidasAprovacao);
                } else if(this.tabIndex == 2) {
                    this.popularFiltroTab(this.filtrosRequisicaoGofsTesoureiro, this.configTableRequisicaoGofsTesoureiro);
                }

                this.consultar();
            },
            popularFiltroTab(filtroTab, configTable){
                if(this.filtro.campoFiltro == 'Número Requisição') {
                    filtroTab.numeroRequisicao = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Tipo Requisição') {
                    filtroTab.tipoRequisicacao = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Processo') {
                    filtroTab.cnj = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    filtroTab.filtrarContribuinte = this.filtro.filtrarEm;
                    filtroTab.contribuinte = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Data Emissão') {
                    filtroTab.filtrarDataEmissao = this.filtro.filtrarEm;
                    filtroTab.dataEmissao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Data Transf.') {
                    filtroTab.filtrarDataTransferencia = this.filtro.filtrarEm;
                    filtroTab.dataTransferencia = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Forma Pagamento') {
                    filtroTab.formaPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Tipo Pagamento') {
                    filtroTab.tipoPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Valor') {
                    filtroTab.filtrarValor = this.filtro.filtrarEm;
                    filtroTab.valor = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                    filtroTab.situacao = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Cadastrada por (serv/estag)' || this.filtro.campoFiltro == 'Usuário Responsável') {
                    filtroTab.filtrarUsuarioInclusao = this.filtro.filtrarEm;
                    filtroTab.usuarioInclusao = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'A ser aprovada por (Procurador)') {
                    filtroTab.filtrarProcurador = this.filtro.filtrarEm;
                    filtroTab.procurador = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Setor') {
                    filtroTab.filtrarSetor = this.filtro.filtrarEm;
                    filtroTab.setor = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Observações') {
                    filtroTab.filtrarObservacoes = this.filtro.filtrarEm;
                    filtroTab.observacoes = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Documentos Anexos') {
                    filtroTab.filtrarDocumentos = this.filtro.filtrarEm;
                    filtroTab.documentos = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Validação GOFS') {
                    filtroTab.validacaoGofs = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Validação Tesoureiro') {
                    filtroTab.validacaoTesoureiro = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'CDAs') {
                    filtroTab.cda = this.filtro.campoMascara;
                }

                configTable.currentPage = 1;
            },
            ordenarResultados(order) {
                if(this.tabIndex == 0) {
                    this.atribuirOrdemFiltroTab(this.configTableCriadasUsuario);
                    this.configTableCriadasUsuario.sortOrder = order;
                } else if(this.tabIndex == 1) {
                    this.atribuirOrdemFiltroTab(this.configTableSubmetidasAprovacao);
                    this.configTableSubmetidasAprovacao.sortOrder = order;
                } else if(this.tabIndex == 2) {
                    this.atribuirOrdemFiltroTab(this.configTableRequisicaoGofsTesoureiro);
                    this.configTableRequisicaoGofsTesoureiro.sortOrder = order;
                }

                this.consultar();
            },
            atribuirOrdemFiltroTab(configTable){
                if(this.filtro.campoFiltro == 'Número Requisição') {
                    configTable.sortField = 'pesquisa.numerorequisicao';
                } else if(this.filtro.campoFiltro == 'Tipo Requisição') {
                    configTable.sortField = 'pesquisa.tiporequisicao';
                } else if(this.filtro.campoFiltro == 'Processo') {
                    configTable.sortField = 'pesquisa.processo';
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    configTable.sortField = 'pesquisa.nomecontribuinte';
                } else if(this.filtro.campoFiltro == 'Data Emissão') {
                    configTable.sortField = 'pesquisa.dataemissao';
                } else if(this.filtro.campoFiltro == 'Data Transf.') {
                    configTable.sortField = 'pesquisa.datatransferencia';
                } else if(this.filtro.campoFiltro == 'Forma Pagamento') {
                    configTable.sortField = 'pesquisa.formapagamento';
                } else if(this.filtro.campoFiltro == 'Tipo Pagamento') {
                    configTable.sortField = 'pesquisa.tipopagamento';
                } else if(this.filtro.campoFiltro == 'Valor') {
                    configTable.sortField = 'pesquisa.valor';
                } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                    configTable.sortField = 'pesquisa.situacao';
                } else if(this.filtro.campoFiltro == 'Cadastrada por (serv/estag)' || this.filtro.campoFiltro == 'Usuário Responsável') {
                    configTable.sortField = 'pesquisa.nomeinclusao';
                } else if(this.filtro.campoFiltro == 'A ser aprovada por (Procurador)') {
                    configTable.sortField = 'pesquisa.nomeprocurador';
                } else if(this.filtro.campoFiltro == 'Setor') {
                    configTable.sortField = 'pesquisa.setor';
                } else if(this.filtro.campoFiltro == 'Observações') {
                    configTable.sortField = 'pesquisa.observacoes';
                } else if(this.filtro.campoFiltro == 'Documentos Anexos') {
                    configTable.sortField = 'pesquisa.documentos';
                } else if(this.filtro.campoFiltro == 'Validação GOFS') {
                    configTable.sortField = 'pesquisa.validaoGofs';
                } else if(this.filtro.campoFiltro == 'Validação Tesoureiro') {
                    configTable.sortField = 'pesquisa.validacaoTesoureiro';
                } else if(this.filtro.campoFiltro == 'CDAs') {
                    configTable.sortField = 'pesquisa.cdas';
                }
            },
            listarPorPendencia(pendentes){
                this.filtrosRequisicaoGofsTesoureiro = {
                    numeroRequisicao: null,
                    tipoRequisicacao: null,
                    cnj: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarUsuarioInclusao: null,
                    usuarioInclusao: null,
                    filtrarSetor: null,
                    setor: null,
                    filtrarObservacoes: null,
                    observacoes: null,
                    filtrarDocumentos: null,
                    documentos: null,
                    validacaoGofs: null,
                    validacaoTesoureiro: null,
                    aprovadasReprovadas: pendentes
                };
                this.selectedsRequisicaoGofsTesoureiro = [];
                this.consultar();
            },
            abrirExtrato(item) {
                if(item.tabelaOrigem == 0) {
                    this.$refs['extratoDiversas'].abrirExtrato(item);
                } else if(item.tabelaOrigem == 1) {
                    this.$refs['extratoHonorariosAcaoJudicial'].abrirExtrato(item);
                } else if(item.tabelaOrigem == 2) {
                    this.$refs['extratoComunicacaoTransferencia'].abrirExtrato(item);
                } else if(item.tabelaOrigem == 3) {
                    this.$refs['extratoHonorariosProtesto'].abrirExtrato(item);
                } else if(item.tabelaOrigem == 4) {
                    this.$refs['extratoHonorariosEfSefa'].abrirExtrato(item);
                } else if(item.tabelaOrigem == 5) {
                    this.$refs['extratoHonorariosComTransfEfSefa'].abrirExtrato(item);
                }
            },
            
            abrirExtratoCda(numeroCda) {
              this.$refs['extratoCda'].abrirExtrato(numeroCda);
            },
            
            limparFiltros() {
                if(this.tabIndex == 0) {
                    this.filtrosCriadasUsuario = {
                        numeroRequisicao: null,
                        tipoRequisicacao: null,
                        cnj: null,
                        filtrarContribuinte: null,
                        contribuinte: null,
                        filtrarDataEmissao: null,
                        dataEmissao: null,
                        tipoPagamento: null,
                        formaPagamento: null,
                        filtrarValor: null,
                        valor: null,
                        filtrarUsuario: null,
                        usuario: null,
                        situacao: null
                    };
                } else if(this.tabIndex == 1) {
                    this.filtrosSubmetidasAprovacao = {
                        numeroRequisicao: null,
                        tipoRequisicacao: null,
                        cnj: null,
                        filtrarContribuinte: null,
                        contribuinte: null,
                        filtrarDataEmissao: null,
                        dataEmissao: null,
                        tipoPagamento: null,
                        formaPagamento: null,
                        filtrarValor: null,
                        valor: null,
                        filtrarUsuario: null,
                        usuario: null,
                        situacao: null,
                        filtrarUsuarioInclusao: null,
                        usuarioInclusao: null,
                        filtrarProcurador: null,
                        procurador: null,
                    };
                } else if(this.tabIndex == 2) {
                    this.filtrosRequisicaoGofsTesoureiro = {
                        numeroRequisicao: null,
                        tipoRequisicacao: null,
                        cnj: null,
                        filtrarContribuinte: null,
                        contribuinte: null,
                        filtrarValor: null,
                        valor: null,
                        filtrarUsuarioInclusao: null,
                        usuarioInclusao: null,
                        filtrarSetor: null,
                        setor: null,
                        filtrarObservacoes: null,
                        observacoes: null,
                        filtrarDocumentos: null,
                        documentos: null,
                        validacaoGofs: null,
                        validacaoTesoureiro: null,
                        aprovadasReprovadas: false
                    };
                }

                this.consultar();
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let userData = JSON.parse(this.$store.getters.getUser);
            if (userData.groups) {
                for (let i = 0; i < userData.groups.length; i++) {
                    if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                        this.admin = true;
                    } else if(userData.groups[i] == 'SFEPGE-ADMINISTRATIVO') {
                        this.administrativo = true;
                    } else if(userData.groups[i] == 'SFEPGE-GOFS') {
                        this.gofs = true;
                    } else if(userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                        this.tesoureiro = true;
                    } else if(userData.groups[i] == 'SFEPGE-PROCURADOR') {
                        this.procurador = true;
                    }
                }
            }

            this.consultarPorTipo('consultarRequisicoesUsuario',
                this.configTableCriadasUsuario,
                this.filtrosCriadasUsuario);
            if(this.admin || this.procurador) {
                this.consultarPorTipo('consultarRequisicoesAprovacao',
                    this.configTableSubmetidasAprovacao,
                    this.filtrosSubmetidasAprovacao);
            }
            if(this.admin || this.gofs || this.tesoureiro) {
                this.consultarPorTipo('consultarRequisicoesValidacoes',
                    this.configTableRequisicaoGofsTesoureiro,
                    this.filtrosRequisicaoGofsTesoureiro);
            }
        },
        
    }
</script>
